// Shared "leaving an edit with unsaved changes" guard.
//
// Every explicit-Save edit pane in the app (Reminder Assignments, Contacts,
// Properties) follows the same rule: edits are NEVER auto-saved on blur or
// click-away — you Save or you Cancel. The trap is that switching to another
// row, toggling the editor shut, or hitting Cancel used to *silently* drop the
// draft. This helper makes that one consistent affordance: if there are unsaved
// changes, ask before discarding; otherwise proceed without nagging.
//
// It is backed by an in-app dialog (DiscardConfirmHost) rather than the native
// window.confirm, so the prompt matches the app's styling and — crucially —
// behaves well on mobile / installed-PWA / webview contexts where the native
// dialog renders poorly or is suppressed. The call is async:
//
//   if (!(await confirmDiscard(dirty))) return;   // user chose to keep editing
export const DISCARD_MESSAGE = 'You have unsaved changes. Discard them?';

let opener = null;   // registered by the mounted <DiscardConfirmHost />

export function registerConfirmHost(fn) { opener = fn; }

export function confirmDiscard(isDirty) {
  if (!isDirty) return Promise.resolve(true);
  // Open the in-app dialog and resolve with the user's choice.
  if (opener) return new Promise(resolve => opener(resolve));
  // Fallback if the host isn't mounted (e.g. unit tests): native confirm.
  return Promise.resolve(window.confirm(DISCARD_MESSAGE));
}
